module.exports = __webpack_public_path__ + "media/images/rotate-camera-5162250f1fe89fa9b7bde770245872d657a76230525033497175572893265a85.png";